import { useEffect, useState } from "react";
import { getItemTitleList } from "../api";
import { selectedProject } from "../config";

// Madde başlık listesi referans veridir: oturum boyunca bir kez çekilir.
// Hem bellekte hem sessionStorage'da tutulur, böylece sayfalar arası gezinmede
// ve sayfa yenilemede tekrar istek atılmaz, sayfa yavaşlamaz.
const STORAGE_KEY = `item_titles_v1_p${selectedProject.id}`;

let memoryCache = null;
let inflight = null;

const loadFromSession = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    return Array.isArray(parsed) && parsed.length ? parsed : null;
  } catch {
    return null;
  }
};

// sessionStorage'ı şişirmemek için sadece gerekli alanları sakla.
const slimDown = (rows) =>
  (rows || []).map((x) => ({
    id: x.id,
    title: x.title,
    definition: x.definition || "",
    primaryImage: x.primaryImage || "",
  }));

const fetchTitles = async () => {
  if (memoryCache) return memoryCache;

  const fromSession = loadFromSession();
  if (fromSession) {
    memoryCache = fromSession;
    return memoryCache;
  }

  if (!inflight) {
    inflight = getItemTitleList()
      .then((res) => {
        const data = slimDown(res?.data || []);
        memoryCache = data;
        try {
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        } catch {
          // kota dolarsa yoksay, bellek cache yeterli
        }
        return data;
      })
      .catch(() => [])
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
};

export default function useItemTitles() {
  const [titles, setTitles] = useState(memoryCache || []);
  const [loading, setLoading] = useState(!memoryCache);

  useEffect(() => {
    let active = true;

    if (memoryCache) {
      setTitles(memoryCache);
      setLoading(false);
      return;
    }

    setLoading(true);
    fetchTitles().then((data) => {
      if (!active) return;
      setTitles(data);
      setLoading(false);
    });

    return () => {
      active = false;
    };
  }, []);

  return { titles, loading };
}
